module.exports = __webpack_public_path__ + "static/media/popcorn.926a7d68.png";